// Surface build-state scores for logic docs — keyed by doc path
// (e.g. "workspace/ad-hoc-tasks"). Update data/surface-build-progress.json
// as audits land.

import raw from '../../data/surface-build-progress.json';

export type SurfaceProgressScores = {
  dataModel: number;
  backend: number;
  ui: number;
  total: number;
};

export type SurfaceProgress = SurfaceProgressScores & {
  /** Main-branch baseline scores, when present. */
  previous?: SurfaceProgressScores;
  /** Worktree branch that produced the displayed scores, when not main. */
  worktree?: string;
};

export type SurfaceBuildProgressFile = {
  updated: string;
  source: string;
  context?: string;
  note?: string;
  rubric: { dataModel: number; backend: number; ui: number };
  surfaces: Record<string, SurfaceProgress>;
};

export const SURFACE_BUILD_PROGRESS = raw as SurfaceBuildProgressFile;

export function getSurfaceProgress(docKey: string): SurfaceProgress | undefined {
  return SURFACE_BUILD_PROGRESS.surfaces[docKey];
}

/** Matches tracker bands: <20 not started · 20–74 partial · ≥75 done. */
export function progressColor(pct: number): string {
  if (pct >= 75) return 'var(--state-online)';
  if (pct >= 20) return 'var(--state-warning)';
  return 'var(--ink-tertiary)';
}
